import promotionContent from './promotionContent.vue';
import launchPlan from './launchPlan.vue';
import promotionMaterial from './promotionMaterial.vue';
import confirmKeyword from './confirmKeyword.vue';
import regionBudget from './regionBudget.vue';
import confirmAdditional from './confirmAdditional.vue';
let stepList = [
	{
		number: 1,
		text: '确认推广内容',
		name: promotionContent,
		tipTitle: '您想在Google推广那些内容？',
		explain:
			'您可以选择网站上的产品分类或产品作为广告投放的目标，采购商点击广告后会跳转至相应的产品页面。',
	},
	{
		number: 2,
		text: '完善推广资料',
		name: promotionMaterial,
		tipTitle: '为您推广内容完善资料',
		explain:
			'对于您选择的推广内容，需要完善相应的广告文案。好的广告语，一定要符合简单直观的特点，明确表达产品的卖点，让采购商知道我们是做什么的，能给他们带来什么编写完成的内容，会以右侧的广告展示效果样式出现在谷歌搜索结果页上。',
	},
	{
		number: 3,
		text: '确认关键词',
		name: confirmKeyword,
		tipTitle: '确认推广内容相关的关键词',
		explain:
			'您选择用来描述您的产品或服务的字词或词组，您选择的关键字将用于向用户展示您的广告，当用户在Google上使用与您的关键字类似的搜索字词以及您的关键字匹配类型进行搜索时，您的广告就可能会展示。',
	},
	{
		number: 4,
		text: '选择国家地区及预算',
		name: regionBudget,
		tipTitle: '确认推广国家地区和预算',
		explain:
			'Google 必须遵守美国财政部外国资产控制办公室 (OFAC) 实施的制裁。因此，部分国家或地区（随附条件 ID）的广告客户无法使用 Google Ads。',
		// 取消俄罗斯注释
		// tips: '苏丹 (2736)<br/><div>注：虽然没有列出俄罗斯，但是目前俄罗斯也被制裁无法投放。</div>',
	},
	{
		number: 5,
		text: '确认附加信息',
		name: confirmAdditional,
		tipTitle: '确认附加信息',
		explain:
			'通过在您的广告中添加更多内容，附加信息可提高广告的醒目程度，使其在搜索结果页上更加显眼，通过额外信息扩展您的广告，以便为用户提供更多理由来选择您。请注意：附加信息是概率性展示，添加附加信息并不能保证附加信息一定会始终随您的广告一同展示。',
	},
	{
		number: 6,
		text: '确认上线方案',
		name: launchPlan,
		tipTitle: '欢迎使用全球赢，您的网站已成功上线，您的专属优化师已为您创建推广方案，请您确认',
		explain: '',
	},
];
export default stepList;
